import { render, staticRenderFns } from "./ListadoPermisos.vue?vue&type=template&id=462be16c&scoped=true"
import script from "./ListadoPermisos.vue?vue&type=script&lang=js"
export * from "./ListadoPermisos.vue?vue&type=script&lang=js"
import style0 from "./ListadoPermisos.vue?vue&type=style&index=0&id=462be16c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462be16c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462be16c')) {
      api.createRecord('462be16c', component.options)
    } else {
      api.reload('462be16c', component.options)
    }
    module.hot.accept("./ListadoPermisos.vue?vue&type=template&id=462be16c&scoped=true", function () {
      api.rerender('462be16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/globals/permisos/ListadoPermisos.vue"
export default component.exports